import { useState } from 'react';
import { LogOut, PackageOpen } from 'lucide-react';

import BagCreatePage from './components/BagCreatePage';
import BarcodeEpcMatchingPage from './components/BarcodeEpcMatchingPage';
import BagDetailsPage from './components/BagDetailsPage';

function App() {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState('bag-details');
  const [selectedBagId, setSelectedBagId] = useState<string | null>(null);
  const [selectedLanguage, setSelectedLanguage] = useState('tr');
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const userName = 'Tablet Kullanıcısı';

  const languages = [
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'en', name: 'English', flag: '🇬🇧' }
  ];

  // Çuval listesi (App seviyesinde tutuluyor)
  const [bags, setBags] = useState([
    {
      id: '1',
      epc: '3074257BF7194E4000001A85',
      acceptanceDate: '2025-12-04 08:30',
      status: 'Kabul Edildi',
      bagCode: 'BAG001',
      totalCost: 4500,
      stockCode: 'STK001',
      stockName: 'Klasik Fit Polo Yaka T-Shirt',
      weight: 60
    },
    {
      id: '2',
      epc: '3074257BF7194E4000001A86',
      acceptanceDate: '2025-12-04 08:45',
      status: 'Kabul Edildi',
      bagCode: 'BAG002',
      totalCost: 5200,
      stockCode: 'STK002',
      stockName: 'Slim Fit Uzun Kollu Gömlek',
      weight: 60
    },
    {
      id: '3',
      epc: '3074257BF7194E4000001A87',
      acceptanceDate: '2025-12-04 09:00',
      status: 'Kabul Edildi',
      bagCode: 'BAG003',
      totalCost: 4800,
      stockCode: 'STK003',
      stockName: 'Regular Fit Basic T-Shirt',
      weight: 60
    },
    {
      id: '4',
      epc: '3074257BF7194E4000001A88',
      acceptanceDate: '2025-12-04 09:15',
      status: 'Kabul Edildi',
      bagCode: 'BAG004',
      totalCost: 5500,
      stockCode: 'STK004',
      stockName: 'Regular Fit Denim Pantolon',
      weight: 60
    },
    {
      id: '5',
      epc: '3074257BF7194E4000001A89',
      acceptanceDate: '2025-12-04 09:30',
      status: 'Kabul Edildi',
      bagCode: 'BAG005',
      totalCost: 4200,
      stockCode: 'STK005',
      stockName: 'Slim Fit Blazer Ceket',
      weight: 60
    },
    {
      id: '6',
      epc: '3074257BF7194E4000001A90',
      acceptanceDate: '2025-12-04 10:00',
      status: 'Kabul Edildi',
      bagCode: 'MIX-BAG001',
      totalCost: 7500,
      stockCode: 'MIX',
      stockName: 'Mix Çuval',
      weight: 60
    },
    {
      id: '7',
      epc: '3074257BF7194E4000001A91',
      acceptanceDate: '2025-12-04 10:30',
      status: 'Kabul Edildi',
      bagCode: 'BFS-BAG001',
      totalCost: 8000,
      stockCode: 'BFS',
      stockName: 'BFS Çuval',
      weight: 60
    }
  ]);

  const menuItems = [
    {
      id: 'bag-details',
      label: 'Çuval İşlemleri',
      icon: PackageOpen
    },
  ];

  return (
    <div className="h-screen bg-slate-50 flex overflow-hidden">
      {/* Minimal Sidebar - Her zaman görünür */}
      <div className="w-16 bg-white shadow-lg border-r border-slate-200 flex flex-col items-center py-4">
        {/* Mini Logo */}
        <div className="mb-8">
          <h1 className="text-xl font-extrabold text-blue-600">EW</h1>
        </div>

        {/* Mini Navigation */}
        <div className="flex-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => setActivePage(item.id)}
                className={`w-12 h-12 mb-2 flex items-center justify-center rounded-lg 
                  ${activePage === item.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                  } transition-colors`}
                title={item.label}
              >
                <Icon className="w-6 h-6" />
              </button>
            );
          })}
        </div>

        {/* Mini Logout */}
        <button
          className="w-12 h-12 flex items-center justify-center rounded-lg 
            text-slate-400 hover:bg-red-50 hover:text-red-500 transition-colors"
          title="Çıkış Yap"
        >
          <LogOut className="w-6 h-6" />
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1">



        {/* Main Content Area - Daha geniş alan */}
        <main className="p-2 max-w-[calc(100vw-4rem)]">
          {(activePage === 'bag-opening' || activePage === 'bag-details') && (
            <BagDetailsPage
              bags={bags}
              initialBagId={selectedBagId}
              onApprove={(bagId: string, splitWeight: number, epc: string) => {
                setBags((prev: any[]) => {
                  const items = [...prev];
                  const idx = items.findIndex(b => b.id === bagId);

                  if (idx > -1) {
                    const parent = items[idx];

                    // 1. Yeni çuvalı oluştur (Ana kaydın kopyası)
                    const newBag = {
                      ...parent,
                      id: Math.random().toString(36).substr(2, 9),
                      epc: epc,
                      bagCode: epc.replace('BAG-', 'B-'),
                      weight: Number(splitWeight.toFixed(2))
                    };

                    const remainingWeight = Number(((parent.weight || 0) - splitWeight).toFixed(2));

                    if (remainingWeight > 0.05) {
                      // Ana çuvalı güncelle ve yeni kaydı hemen yanına ekle
                      items[idx] = { ...parent, weight: remainingWeight };
                      items.splice(idx + 1, 0, newBag);
                      return items;
                    } else {
                      // Ana çuval tükendi ise sadece yer değiştir
                      items[idx] = newBag;
                      return items;
                    }
                  }
                  return items;
                });
                setActivePage('bag-details');
                setSelectedBagId(null);
              }}
              onClose={() => setActivePage('bag-opening')}
            />
          )}
          {activePage === 'bag-create' && <BagCreatePage />}
          {activePage === 'barcode-epc-matching' && <BarcodeEpcMatchingPage />}
        </main>
      </div>
    </div>
  );
}

export default App;
